module.exports = __webpack_public_path__ + "img/backupAct.40c47fc3.png";